import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { AgendaEmpresaResponse } from 'src/app/admihair/api/dto/agenda-empresa-response';
import { PageResponse } from 'src/app/admihair/api/dto/paginacao/page-response';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { AgendaEmpresaService } from 'src/app/admihair/service/agenda-empresa.service';

@Component({
  selector: 'app-profissional-agenda-detalhe',
  templateUrl: './profissional-agenda-detalhe.component.html',
  styleUrls: ['./profissional-agenda-detalhe.component.scss']
})
export class ProfissionalAgendaDetalheComponent implements OnInit, OnChanges {

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() profissional?: Profissional;
  @Input() dataSelecionada?: Date;
  @Output() selecionar = new EventEmitter<number>();

  agendamentos: AgendaEmpresaResponse[] = [];
  totalRegistros: number = 0;
  loading: boolean = false;

  listaStatus: string[] = ['FUTUROS', 'PASSADOS'];
  statusSelecionado: string = 'FUTUROS';

  dataInicio: Date = new Date();
  dataFim: Date = this.adicionarDias(new Date(), 7);

  private lazyParams: LazyLoadEvent = {
    first: 0,
    rows: 5
  };

  constructor(private agendaEmpresaService: AgendaEmpresaService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true) {
      this.resetarEstado();
      this.resetarPaginacao();
    }
  }

  onLazyLoad(event: LazyLoadEvent) {
    if (!this.visible) {
      return;
    }
    this.lazyParams = event;
    this.loading = true;
    this.carregarDados();
  }

  carregarDados() {
    if (!this.profissional || !this.profissional.id) {
      return;
    }
    this.agendaEmpresaService.listarPorProfissional(
      this.profissional.id,
      this.dataSelecionada,
      this.statusSelecionado,
      this.obterPagina(),
      this.obterTamanhoPagina()
    ).subscribe({
      next: (data: PageResponse<AgendaEmpresaResponse>) => {
        this.agendamentos = data.content;
        this.totalRegistros = data.totalElements;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;

      }
    })
  }

  filtrar() {
    this.loading = true;
    this.carregarDados();
  }

  abrirDetalhe(agendamentoId: number) {
    this.selecionar.emit(agendamentoId);
  }

  fechar() {
    this.visibleChange.emit(false);
  }

  resetarEstado() {
    this.agendamentos = [];
    this.statusSelecionado = 'FUTUROS';
    this.totalRegistros = 0;
    this.loading = true;
  }

  resetarPaginacao() {
    this.lazyParams = {
      ...this.lazyParams,
      first: 0
    };
  }


  obterTamanhoPagina(): number {
    return this.lazyParams.rows ?? 5;
  }
  obterPagina(): number {
    return (this.lazyParams.first ?? 0) / (this.lazyParams.rows ?? 5);
  }

  private adicionarDias(data: Date, dias: number): Date {
    const resultado = new Date(data);
    resultado.setDate(resultado.getDate() + dias);
    return resultado;
  }

}
